import { createContext, useContext, useState } from "react"

const FlashcardContext = createContext()
export const useFlashcard = () => useContext(FlashcardContext)

const FlashcardProvider = ({ children, cardIndex, blockID }) => {
  const [editingText, setEditingText] = useState(null)
  const [isFlipped, setIsFlipped] = useState(false)

  return (
    <FlashcardContext.Provider
      value={{
        cardIndex,
        editingText,
        setEditingText,
        isFlipped,
        setIsFlipped,
        blockID
      }}
    >
      {children}
    </FlashcardContext.Provider>
  )
}

export default FlashcardProvider
